export const tncShortPartyPPI = `
<html
    ><head
        ><meta
            content="text/html; charset=UTF-8"
            http-equiv="content-type" /><style type="text/css">
            @import url(https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI);
            ul.lst-kix_y7j6ux2zacqu-7 {
                list-style-type: none;
            }
            ul.lst-kix_y7j6ux2zacqu-6 {
                list-style-type: none;
            }
            li.li-bullet-0:before {
                margin-left: -18pt;
                white-space: nowrap;
                display: inline-block;
                min-width: 18pt;
            }
            ul.lst-kix_y7j6ux2zacqu-8 {
                list-style-type: none;
            }
            ul.lst-kix_y7j6ux2zacqu-3 {
                list-style-type: none;
            }
            .lst-kix_y7j6ux2zacqu-4 > li:before {
                content: "\\25cb   ";
            }
            ul.lst-kix_y7j6ux2zacqu-2 {
                list-style-type: none;
            }
            .lst-kix_y7j6ux2zacqu-3 > li:before {
                content: "\\25cf   ";
            }
            .lst-kix_y7j6ux2zacqu-5 > li:before {
                content: "\\25a0   ";
            }
            ul.lst-kix_y7j6ux2zacqu-5 {
                list-style-type: none;
            }
            ul.lst-kix_y7j6ux2zacqu-4 {
                list-style-type: none;
            }
            .lst-kix_y7j6ux2zacqu-2 > li:before {
                content: "\\25a0   ";
            }
            .lst-kix_y7j6ux2zacqu-6 > li:before {
                content: "\\25cf   ";
            }
            ul.lst-kix_y7j6ux2zacqu-1 {
                list-style-type: none;
            }
            ul.lst-kix_y7j6ux2zacqu-0 {
                list-style-type: none;
            }
            .lst-kix_y7j6ux2zacqu-0 > li:before {
                content: "\\25cf   ";
            }
            .lst-kix_y7j6ux2zacqu-8 > li:before {
                content: "\\25a0   ";
            }
            .lst-kix_y7j6ux2zacqu-1 > li:before {
                content: "\\25cb   ";
            }
            .lst-kix_y7j6ux2zacqu-7 > li:before {
                content: "\\25cb   ";
            }
            ol {
                margin: 0;
                padding: 0;
            }
            table td,
            table th {
                padding: 0;
            }
            .c6 {
                -webkit-text-decoration-skip: none;
                color: #000000;
                font-weight: 400;
                text-decoration: underline;
                vertical-align: baseline;
                text-decoration-skip-ink: none;
                font-size: 12pt;
                font-family: "Roboto";
                font-style: normal;
            }
            .c3 {
                margin-left: 36pt;
                padding-top: 0pt;
                padding-left: 0pt;
                padding-bottom: 0pt;
                line-height: 1.15;
                orphans: 2;
                widows: 2;
                text-align: justify;
            }
            .c2 {
                padding-top: 0pt;
                padding-bottom: 0pt;
                line-height: 1.15;
                orphans: 2;
                widows: 2;
                text-align: left;
                height: 11pt;
            }
            .c0 {
                color: #000000;
                font-weight: 400;
                text-decoration: none;
                vertical-align: baseline;
                font-size: 12pt;
                font-family: "Roboto";
                font-style: normal;
            }
            .c1 {
                color: #000000;
                font-weight: 700;
                text-decoration: none;
                vertical-align: baseline;
                font-size: 12pt;
                font-family: "Roboto";
                font-style: normal;
            }
            .c4 {
                padding-top: 0pt;
                padding-bottom: 0pt;
                line-height: 1.15;
                orphans: 2;
                widows: 2;
                text-align: justify;
            }
            .c9 {
                padding-top: 0pt;
                padding-bottom: 0pt;
                line-height: 1.15;
                orphans: 2;
                widows: 2;
                text-align: center;
            }
            .c8 {
                background-color: transparent;
                max-width: 100%;
                padding: 0;
            }
            .c7 {
                padding: 0;
                margin: 0;
            }
            .c5 {
                height: 11pt;
            }
            .title {
                padding-top: 0pt;
                color: #000000;
                font-size: 26pt;
                padding-bottom: 3pt;
                font-family: "Arial";
                line-height: 1.15;
                page-break-after: avoid;
                orphans: 2;
                widows: 2;
                text-align: left;
            }
            .subtitle {
                padding-top: 0pt;
                color: #666666;
                font-size: 15pt;
                padding-bottom: 16pt;
                font-family: "Arial";
                line-height: 1.15;
                page-break-after: avoid;
                orphans: 2;
                widows: 2;
                text-align: left;
            }
        </style></head
    ><body class="c8 doc-content"
        ><p class="c9"
            ><span class="c1">Pororo Park &amp; Tayo Station </span></p
        ><p class="c2"><span class="c0"></span></p
        ><p class="c4"><span class="c6">Party Terms and Conditions </span></p
        ><ul class="c7 lst-kix_y7j6ux2zacqu-0 start"
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Birthday Party reservations must be made no later than 7
                    days before the event, and full payment must be completed no
                    later than 4 days prior to the event date.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Food and beverages from outside are allowed, but may only
                    be consumed inside the Party Room. Please note that dining
                    utensils are not provided, and alcoholic beverages are
                    strictly prohibited.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >The maximum duration for using the Party Room and Play Area
                    is 3 hours, based on the booked time slot.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Activities such as candle blowing and group photos are only
                    permitted inside the Party Room.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Children under 7 years old must be accompanied by an adult
                    (17 years or older) while playing in the area.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Decoration details (including dimensions and weight) must
                    be submitted no later than 6 days before the event for mall
                    approval purposes.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >All decoration themes, including any copyright or
                    Intellectual Property (IP) related to characters or designs
                    used, as well as the Loading In and Out process, are fully
                    the Client&rsquo;s responsibility.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >The following items are strictly prohibited: Helium
                    balloons, confetti, blow torches, and any type of heating
                    equipment (such as stoves, microwaves, sterno gel,
                    etc.).</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >It is strictly prohibited to attach, nail, or use glue,
                    double-sided tape, or adhesive tape on any surfaces in order
                    to maintain the condition of the property.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Additional Party Rooms may be provided if the number of
                    guests exceeds capacity; however, availability is subject to
                    conditions on the event day. Clients are encouraged to
                    inform in advance for availability checking.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Party Room allocation is assigned randomly by management
                    and is subject to availability.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >You are permitted to arrive up to 30 minutes prior to the
                    event start time for preparation inside the party
                    room.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Additional charges will apply for children and companions
                    exceeding the package quota.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Additional guests outside the submitted Guest List, as well
                    as Grip Socks, will be charged and must be settled after the
                    event at the Ticketing Counter.</span
                ></li
            ></ul
        ><p class="c4 c5"><span class="c0"></span></p
        ><p class="c4 c5"><span class="c0"></span></p
        ><p class="c4 c5"><span class="c0"></span></p
        ><p class="c4 c5"><span class="c0"></span></p
        ><p class="c4 c5"><span class="c0"></span></p
        ><p class="c4"><span class="c6">Terms &amp; Conditions</span></p
        ><ul class="c7 lst-kix_y7j6ux2zacqu-0"
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >All payments made are non-cancelable and non-refundable,
                    including Packages and Add-Ons.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >No partial refunds will be provided if the number of
                    attendees is less than the confirmed number.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Requests for reschedule or Force Majeure may be
                    accommodated with additional charges, subject to company
                    policy and session availability.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Any changes to schedule or technical arrangements will be
                    reviewed on a case-by-case basis and remain subject to
                    management approval.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >In the event of any violation of property rules or
                    prohibited items, the Client agrees to be charged penalties
                    or recovery costs in accordance with applicable
                    regulations.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >The Client is fully responsible for any damage to
                    facilities caused by misuse or negligence during the
                    event.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Management reserves the right to document the event for
                    promotional purposes, unless the Client provides written
                    notice otherwise prior to the event.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >Management reserves the right to terminate the Birthday
                    session if any guest engages in verbal abuse toward staff or
                    violates the applicable House Rules.</span
                ></li
            ><li class="c3 li-bullet-0"
                ><span class="c0"
                    >These Terms &amp; Conditions are subject to change at any
                    time without prior notice.</span
                ></li
            ></ul
        ><p class="c2"><span class="c0"></span></p></body
></html>

`;
